import { render } from "./StackCard.vue?vue&type=template&id=208666c7&scoped=true"
import script from "./StackCard.vue?vue&type=script&lang=js"
export * from "./StackCard.vue?vue&type=script&lang=js"

import "./StackCard.vue?vue&type=style&index=0&id=208666c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208666c7"]])

export default __exports__